import Vue from 'vue'
import { ActionContext } from 'vuex'
import { buildFleetUIStateId } from '@/models/ui/FleetUiState'
import { DETAIL_REFUSED } from '@/utils/tenantModules'
import apiFleet from '@/api/fleet'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IFleetState } from './state'
import { ApiResultCode } from '@/models/response/AlrBase'
import { AloLogbookItem } from '@/models/alo/AloLogbookItem'
import { AloError } from '@/models/alo/AloError'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { AloDbFleet } from '@/models/alodb/AloDbFleet'
import { FleetUi } from '@/models/ui/FleetUi'
import { AloLogbookChannel } from '@/models/alo/AloLogbookChannel'
import { ConsoleRow } from '@/models/ui/ConsoleRow';

export class FleetAction {
  
      
  public [types.FLEET_UNSELECT](context: ActionContext<IFleetState, IRootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.FLEET_UNSELECT)
      resolve()
    })
  }


  public [types.FLEET_SELECT_DETAIL_REQUEST](context: ActionContext<IFleetState, IRootState>, id:number) {
    return new Promise((resolve, reject) => {
      context.dispatch(types.ADMINFLEET_SELECT_DETAIL_REQUEST, id)
        .then((fleet:AloDbFleet) => {
              // BLF037 — flotte refusée par les réglages de son enseigne : aucun onglet ouvert.
              if (!context.getters.isFleetAllowed(fleet)) {
                reject(new Error(DETAIL_REFUSED))
                return
              }
              context.commit(types.ADMINFLEET_SELECT_DETAIL, fleet)
              context.commit(types.FLEET_SELECT_DETAIL_SUCCESS, fleet)
              context.dispatch(types.FLEET_SELECT_DETAIL, fleet.FLE_ID)            
              context.dispatch(types.UI_SHOW_ALL_DRAWER_MISSION_MAP,buildFleetUIStateId(fleet.FLE_ID!,'detail'))                            
              resolve(fleet)                  
        })
        .catch(() => {
          context.commit(types.FLEET_SELECT_DETAIL_ERROR, id)
          reject()
        })
    })
  }

  public [types.FLEET_UNSELECT_DETAIL](context: ActionContext<IFleetState, IRootState>, id:number) {
    context.commit(types.FLEET_UNSELECT_DETAIL, id)
    return context.dispatch(types.UI_RESET_UISTATE, buildFleetUIStateId(id, 'detail'))
  }

  public [types.FLEET_SELECT_DETAIL](context: ActionContext<IFleetState, IRootState>, id:number) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.FLEET_SELECT_DETAIL, id)
      resolve()
    })
  }

  public [types.FLEET_NAVTO_DETAIL](context: ActionContext<IFleetState, IRootState>, { cmp, isleft, id, label }:{ cmp:string, isleft:boolean, id:number, label:string }) {
    context.dispatch(types.UI_SET_MEASURETOOL, 'NONE')
    return new Promise<void>((resolve, reject) => {
      context.commit(types.FLEET_NAVTO_DETAIL, { cmp, isleft, id, label })
      resolve()
    })
  }

  public [types.FLEET_SET_LEFTPANEL_SIZE](context: ActionContext<IFleetState, IRootState>, size:string) {
    context.commit(types.FLEET_SET_LEFTPANEL_SIZE, size)
  }

  public [types.FLEET_UNSELECT_TAB](context: ActionContext<IFleetState, IRootState>, { cmp, isleft, id }:{ cmp:string, isleft:boolean, id:number }) {
    context.commit(types.FLEET_UNSELECT_TAB, { cmp, isleft, id })
    context.dispatch(types.UI_RESET_UISTATE, `${cmp}-${id}`)
  }

  public [types.FLEET_RENAME_DETAIL](context: ActionContext<IFleetState, IRootState>, { cmp, isleft, id, label }:{ cmp:string, isleft:boolean, id:number, label:string }) {
    return new Promise((resolve, reject) => {
      context.commit(types.FLEET_RENAME_DETAIL, { cmp, isleft, id, label })
      resolve(label)
    })
  }

  public [types.FLEET_MOVE_TAB](context: ActionContext<IFleetState, IRootState>, { cmp, isleft, id }:{ cmp:string, isleft:boolean, id:number }) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.FLEET_MOVE_TAB, { cmp, isleft, id })
      resolve()
    })
  }

  public [types.FLEET_SET_ONGOING_FILTER](context: ActionContext<IFleetState, IRootState>, ongoing:boolean) {
    return new Promise((resolve, reject) => {
      context.commit(types.FLEET_SET_ONGOING_FILTER, ongoing)
      resolve(ongoing)
    })
  }

  public [types.FLEET_RESET_FILTER](context: ActionContext<IFleetState, IRootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.FLEET_RESET_FILTER)
      resolve()
    })
  }

  
  

  public [types.FLEET_END](context: ActionContext<IFleetState, IRootState>, id: number) {
    return new Promise((resolve, reject) => {
        
    })
  }

  

 

  
}

export default util.classToObject(FleetAction)